import {FlexRow} from '../../../components/utility/flex_row.tsx';
import {FlexColumn} from '../../../components/utility/flex_column.tsx';
import {Icon} from '../../../components/icon/icon.tsx';
import {Alignment} from '../../../enums/alignment.ts';
import {Widget} from '../../../components/widget/widget.tsx';
import {AltButton} from '../../../components/button/alt_button.tsx';
import {ButtonPosition} from '../../../enums/button_position.ts';
import {hasDisabledPreference} from '../../../support/get_data.ts';
import {useAppSelector} from '../../../store/store.ts';
import {__} from '../../../support/lang/translations.ts';

export function NotificationsDisabledWidget() {
    const meData = useAppSelector((state) => state.customerInfo.me?.customer);
    if (!hasDisabledPreference(meData)) {
        return;
    }

    return (
        <Widget isInteractive={true} to="profile?profile_active_tab=preferences">
            <FlexRow>
                <FlexColumn>
                    <FlexRow>
                        <Icon iconClassName="fa-light fa-info-circle" outline={false} />
                        <FlexColumn>
                            <strong style={{marginLeft: '1rem'}}>{__('widgets.notification_disabled.title')}</strong>
                            <span style={{marginLeft: '1rem'}}>{__('widgets.notification_disabled.content')}</span>
                        </FlexColumn>
                    </FlexRow>
                </FlexColumn>

                <FlexColumn alignment={Alignment.End}>
                    <AltButton position={ButtonPosition.Right}>
                        <i className="fa-light fa-arrow-right" />
                    </AltButton>
                </FlexColumn>
            </FlexRow>
        </Widget>
    );
}
